import React, {useState} from 'react';
import axios from 'axios';
import urlList from "../../reducers/propertiesReducer";
import getAxiosConfig from "../../utils/axiosConfig";

const SegmentationSearcher = ({segmentationName}) => {
    const [userId, setUserId] = useState('');
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const handleSearch = async () => {
        try {
            const response = await axios.get(
                `${urlList().segmentationUrl}/getSegmentForUser/${userId}`,
                getAxiosConfig()
            );
            setData(response.data);
        } catch (error) {
            console.error('Error fetching segmentation details:', error);
            setError('Error fetching segmentation details');
        }
    };

    return (
        <div>
            <label>
                Enter user id:
                <input type="text" value={userId} onChange={(e) => setUserId(e.target.value)}/>
            </label>
            <button onClick={handleSearch}>Search</button>

            {data && (
                <div>
                    <h2>User id information</h2>
                    <ul>
                        {Object.entries(data).map(([key, value]) => (
                            (segmentationName === key) && (
                                <li key={key}>
                                    <p>Segmentation name: {value}</p>
                                </li>
                            )
                        ))}
                    </ul>
                </div>
            )}

            {error && <p style={{color: 'red'}}>{error}</p>}
        </div>
    );
};

export default SegmentationSearcher;
